import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiRoot)) {
    return next(req);
  }

  const token = localStorage.getItem(environment.accessTokenName);
  const currentInstitutionKey = localStorage.getItem(environment.institutionKeyName);

  let headers = req.headers;

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }
  if (currentInstitutionKey) {
    headers = headers.set('Institution-Key', currentInstitutionKey);
  }

  // Don't set Content-Type for FormData — browser sets multipart boundary automatically
  if (!(req.body instanceof FormData)) {
    headers = headers.set('Content-Type', 'application/json');
  }

  return next(req.clone({ headers }));
};
